// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1x09C","placeholdersHeader":"styles_placeholdersHeader__3Erut","editorStyle":"styles_editorStyle__1yL3M","placeholdersBox":"styles_placeholdersBox__11QUd"};